export default Object.freeze({
	MOBILE: 'mobile',
	HOME: 'home',
	WORK: 'work',
});
